import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// TODO: Replace with your Firebase config
// Get this from Firebase Console > Project Settings > General > Your apps
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Enable offline persistence (optional - writes will still work without it)
// Note: This may fail if multiple tabs are open, but that's okay - writes still go to server
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open - persistence can only be enabled in one tab
    // This is fine - writes will still work, they just won't be cached offline
    console.info('Firestore persistence: Multiple tabs detected. Using memory cache. Writes will still persist to server.');
  } else if (err.code === 'unimplemented') {
    // Browser doesn't support persistence
    console.info('Firestore persistence: Browser does not support offline persistence. Using memory cache.');
  } else {
    console.warn('Firestore persistence: Failed to enable:', err.message);
  }
  // Don't throw - app should work fine without offline persistence
});

export default app;

